/**
 * Loading attributes for an <img>: eager with high fetch priority for the
 * page's largest paint, lazy otherwise.
 *
 * React 18 doesn't know `fetchPriority` and warns on the camelCase prop, so
 * the attribute goes through lowercase; it is returned as a spread object
 * because the DOM typings only list the camelCase spelling.
 *
 * @param {boolean} priority
 * @returns {{ loading: "eager" | "lazy", fetchpriority?: "high" }}
 */
export function loadingHints(priority) {
	return priority ? { loading: "eager", fetchpriority: "high" } : { loading: "lazy" };
}
